export const UI_PROPS_REQUEST = 'UI_PROPS_REQUEST';
export const UI_PROPS_SUCCESS = 'UI_PROPS_SUCCESS';
export const UI_PROPS_FAILURE = 'UI_PROPS_FAILURE';
export const UI_PROPS = [UI_PROPS_REQUEST, UI_PROPS_SUCCESS, UI_PROPS_FAILURE];

export const UI_PROPS_SELF_REQUEST = 'UI_PROPS_SELF_REQUEST';
export const UI_PROPS_SELF_SUCCESS = 'UI_PROPS_SELF_SUCCESS';
export const UI_PROPS_SELF_FAILURE = 'UI_PROPS_SELF_FAILURE';
export const UI_PROPS_SELF = [UI_PROPS_SELF_REQUEST, UI_PROPS_SELF_SUCCESS, UI_PROPS_SELF_FAILURE];
